import { clientFetch } from '@biw/client-fetch';
import { addError } from 'dux/errors';
import Errors from 'dux/errors/errors';
import { Dispatch } from 'app/types/redux';

/******************
 * Initial state
 */
const initialState = {
    sent: false,
};

/******************
 * Non-async action types
 */
const CONTACT_SENT = 'CONTACT_SENT';
const CONTACT = 'contact';

/*****
 * Reducer
 */
export default function contactUs( state = initialState, action: any ) {
    switch ( action.type ) {
        case CONTACT_SENT:
            return {
                ...state,
                sent: action.requested,
                error: 'error',
            };
        default:
            return state;
    }
}

/******************
 * Action creators
 */
function setContactSent( sent: any ) {
    return {
        type: CONTACT_SENT,
        sent,
    };
}

export function sendContact( reqObj: any ) {
    return ( dispatch: Dispatch, getState: any ) => {

        return clientFetch( {
            url: '/api/v1.0/contactUs',
            method: 'post',
            body: reqObj,
            type: CONTACT,
        } )
            .then( ( response: any ) => {
                if ( response.response === 'Email sent Successfully' ) {
                    dispatch( setContactSent( true ) );
                    window.history.back();
                } else {
                    dispatch( setContactSent( false ) );
                }
            } ).catch( ( error: Error ) => {
                dispatch( addError( error, Errors.ERROR_CONTACTUS_SUBMISSION_FAILED ) );
            } );
    };
}
